import React, { useEffect, useCallback, useState } from 'react';
import Chip from '@mui/material/Chip';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { PictureAsPdf } from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import Textarea from '@mui/joy/Textarea';
import { Box } from '@mui/material';
import "css/generalSettings.css";   
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from 'actions/ErrorActions';
import { helpHttp } from 'service/HelpHttp';
import { setLoading } from 'reducers/loadingSlice'; 
import { ENDPOINT} from "constants/variables";

import PropTypes from 'prop-types';
 

const initialStateEMAIL = {
  "id":"",
  "defaultStore_id":0, 
  "tradename": "",
  "defaultStore_email": "",
  "defaultStore_documentId": "",
  "useraccount_id":0,
  "username": "",
  "useraccount_email": "",
  "createdate": null,
  "store_IdTo": "",
  "store_NameTo": "",
  "store_EmailTo": "",
  "store_DocumentIdTo":"",
  "subjectEmail":"",
  "contentEmail":"",
  "reason_id":0,
  "reason_namees":"",
  "reason_nameen":"",
  "status_id":0,
  "status_namees":"",
  "status_nameen":"",
  "referenceid":0,
  "emailfrom_id":0,
  "emailto_id":0,
  "linesemails":[],
  "updatedFiles":[],
  "formDIDTOs":[]
};

const initialEmailToSelect = [{
  "id":"",
  "tradename": "",
  "contacemail":""
 }];
     
const SendEMAILSettings = ({ showPrincipalMenu }) => {
  const { t,i18n } = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token);
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const useraccount_username = useSelector((state) => state.loginUser.username);  
  const useraccount_email = useSelector((state) => state.loginUser.email);  
  const defaultStore_id = useSelector((state) => state.loginUser.defaultStore.id);  
  const defaultStore_tradename = useSelector((state) => state.loginUser.defaultStore.tradename);  
  const defaultStore_email = useSelector((state) => state.loginUser.defaultStore.email);  
  const defaultStore_documentId = useSelector((state) => state.loginUser.defaultStore.documentid);  
  const defaultStore_destinestore_id = useSelector((state) => state.loginUser.destinestore_id);  
  const defaultStore_destinestore_name = useSelector((state) => state.loginUser.destinestore_name);  
  const defaultStore_emailDestine = useSelector((state) => state.loginUser.emaildestine);  
  const [formEMAIL, SetFormEMAIL] = useState(initialStateEMAIL);
  const [emailsToSelect,setEmailsToSelect]= useState(initialEmailToSelect);  
  const [errorsEMAIL, setErrorsEMAIL] = useState({});
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]); 

  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && showPrincipalMenu) {
        setFiles([]);
        dispatch(setLoading(false));
        setErrorsEMAIL({});
        setEmailsToSelect(initialEmailToSelect);
        SetFormEMAIL(initialStateEMAIL);
      }
    },
    [
      setFiles,
      showPrincipalMenu, 
      setEmailsToSelect,
      dispatch,
      SetFormEMAIL
    ]
  );

  const cleanSettings = () => {
    setFiles([]);
    dispatch(setLoading(false));
    SetFormEMAIL(initialStateEMAIL);
    setErrorsEMAIL({}); 
    SetFormEMAIL(formEMAIL => ({
      ...formEMAIL,
      defaultStore_id:defaultStore_id,
      tradename:defaultStore_tradename,
      defaultStore_email:defaultStore_email, 
      defaultStore_documentId:defaultStore_documentId,  
      useraccount_id:useraccount_id,
      username:useraccount_username,
      useraccount_email:useraccount_email,
      store_IdTo:defaultStore_destinestore_id,
      store_NameTo:defaultStore_destinestore_name,
      store_EmailTo:defaultStore_emailDestine,
      createdate: new Date(),
      linesemails:[],
      updatedFiles:[]
    }));
  };

  const handleBlurDataEditEmail = (e) => {
    handleChangeDataEditEmail(e);
    setErrorsEMAIL(validateFormEmail());
  };

  const handleChangeDataEditEmail = (e) => {
    const { name, value } = e.target;
    SetFormEMAIL(formEMAIL => ({
      ...formEMAIL,
      [name]: value,
    })); 
  };


  const handleBlurDataEditStoreTo = (e) => {
    handleChangeDataEditStoreTo(e);
    setErrorsEMAIL(validateFormEmail());
  };

  const handleChangeDataEditStoreTo = (e) => {
    let idx=emailsToSelect.findIndex(((item) => item.id === Number(e.target.value)));
    SetFormEMAIL(formEMAIL => ({
      ...formEMAIL,
      store_IdTo:emailsToSelect[idx].id || "",
      store_NameTo:emailsToSelect[idx].tradename || "",
      store_EmailTo:emailsToSelect[idx].contacemail || ""    
    })); 
  };

  const validateFormEmail = () => {
    let errorsEMAIL = {};
    //let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (!formEMAIL.store_IdTo || formEMAIL.store_IdTo==="" || formEMAIL.store_IdTo==="0" || formEMAIL.store_IdTo===0) {
      errorsEMAIL.store_IdTo = 'Text_FieldemailsToRequired'; 
    }  

    if (regexInvalidCharacters.test(formEMAIL.subjectEmail)) {
      errorsEMAIL.subjectEmail = 'Text_TextNoValid';
    }

    if (regexInvalidCharacters.test(formEMAIL.contentEmail)) {
      errorsEMAIL.contentEmail = 'Text_TextNoValid';
    }  
    return errorsEMAIL;
  };
 
  const fetchSubmitDataEdit = (dataToSend) => {
    dispatch(setLoading(true));  
    cleanSettings(); 
    console.log(dataToSend)
    const fetchData = async () => {
      try {
        const getData = await helpHttp().post(ENDPOINT, 'sendemail/savesendemail', token, dataToSend);
        if (getData.status === 'OK') {
          dispatch(successErrorAction(t('Text_SaveData')));
          dispatch(setLoading(false));
        } else {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.cause))); 
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }  
    };

    fetchData();  
  
  };

  const handleSubmitDataEdit = () => {
    const errors = validateFormEmail(); 
    setErrorsEMAIL(errors);
    if (Object.keys(errors).length === 0 
        && formEMAIL.store_IdTo !== null
        && formEMAIL.store_IdTo !== ""
        && formEMAIL.store_IdTo !== "0"
        && formEMAIL.store_IdTo !== 0
    ) {
      if (files.length > 0) {
        formEMAIL.updatedFiles = files.map((item, index) => ({
          id: index,
          filename: item.file.name,
          createdate: item.file.lastModified,
          datafile: splitFileBase64(item.data),
          type: item.file.type || splitFileBase64Type(item.data)
        }));
      
        SetFormEMAIL(formEMAIL => ({
          ...formEMAIL,
          defaultStore_id:defaultStore_id,
          tradename:defaultStore_tradename,
          defaultStore_email:defaultStore_email, 
          defaultStore_documentId:defaultStore_documentId,  
          useraccount_id:useraccount_id,
          username:useraccount_username,
          useraccount_email:useraccount_email,
          createdate: new Date()
        }));  
         dispatch(setLoading(false));
        fetchSubmitDataEdit(formEMAIL);
      }else{
        dispatch(warningErrorAction(t('Text_FieldFilesRequired')));
      }
    } else {
      if (errors.store_IdTo) {
        dispatch(warningErrorAction(t(errors.store_IdTo)));
      } else if (errors.subjectEmail) {
        dispatch(warningErrorAction(t(errors.subjectEmail)));
      } else if (errors.contentEmail) {
        dispatch(warningErrorAction(t(errors.contentEmail)));
      } else if (errors.store_IdTo) {
        dispatch(warningErrorAction(t(errors.store_IdTo)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData4')));
      }
    } 
  }; 
  const splitFileBase64 = (fileToConvert) => {
    const arrayAuxiliar = fileToConvert.split(',');
    return arrayAuxiliar[1];
  }; 
  
  const splitFileBase64Type = (fileToConvert) => {
    const arrayAuxiliar = fileToConvert.split(',');
    return arrayAuxiliar[0].replace('data:', '').replace(';base64', '');
  };
 
  const handlePreviewIcon = (fileObject) => {
    const { type } = fileObject.file;
    switch (type) {
      case 'application/pdf':
        return (
          <Box sx={{ bgcolor: '#00000', width: 200, height: 150, justifyContent: 'center', padding: '4px' }}>
            <PictureAsPdf style={{ color: '#e74a3b', width: 50, height: 50 }} />
            <br />
            <br />
            <Chip
              value={fileObject.file.name}
              label={fileObject.file.name}
              clickable={false}
              style={{ color: '#e74a3b', justifyContent: 'center', fontSize: 8 }}
            />
          </Box>
        );
      default:
        return (
          <Box sx={{ bgcolor: '#00000', width: 200, height: 150, justifyContent: 'center', padding: '4px' }}>
            <PictureAsPdf style={{ color: '#e74a3b', width: 50, height: 50 }} />
            <br />
            <br />
            <Chip
              value={fileObject.file.name}
              label={fileObject.file.name}
              clickable={false}
              style={{ color: '#e74a3b', justifyContent: 'center', fontSize: 8 }}
            />
          </Box>
        );
    }
  };

  const handleAddFileContract = (newFiles) => {
    newFiles = newFiles.filter((file) => !files.find((f) => f.data === file.data));
    setFiles([...files, ...newFiles]);
  };

  const handleDeleteFileContract = (deleted) => {
    setFiles(files.filter((f) => f !== deleted));
  };

  useEffect(() => {
    let isMounted = true; 
    const fetchDataEmails = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`store/getemailliststores`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setEmailsToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showPrincipalMenu ) { 
      fetchDataEmails();
    }
    return () => { isMounted = false }; 
  }, [t,token,i18n,dispatch,showPrincipalMenu]);

  useEffect(() => {
    if (  defaultStore_id!==undefined && defaultStore_id!==null && defaultStore_id!=="" && defaultStore_id!=="0" && defaultStore_id!==0 &&
      useraccount_id!==undefined && useraccount_id!==null && useraccount_id!=="" && useraccount_id!=="0" && useraccount_id!==0
      && (formEMAIL.defaultStore_id===0 || useraccount_id===0)
    ){
      SetFormEMAIL(formEMAIL => ({
        ...formEMAIL,
        defaultStore_id:defaultStore_id,
        tradename:defaultStore_tradename,
        defaultStore_email:defaultStore_email, 
        defaultStore_documentId:defaultStore_documentId,  
        useraccount_id:useraccount_id,
        username:useraccount_username,
        useraccount_email:useraccount_email,
        store_IdTo:defaultStore_destinestore_id,
        store_NameTo:defaultStore_destinestore_name,
        store_EmailTo:defaultStore_emailDestine,
        createdate: new Date()
      })); 

    }
  }, [defaultStore_id,useraccount_id,defaultStore_emailDestine,defaultStore_documentId,defaultStore_email,defaultStore_tradename,formEMAIL.defaultStore_id,useraccount_email,useraccount_username,defaultStore_destinestore_id,defaultStore_destinestore_name]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  return (
    <div>
      {showPrincipalMenu && (
        
        <div className="container-fluid formgeneral-send-wrapper">
          {/* Search input */}
          <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '1050px' }}> 
            <div className="formgeneral-card-header">
              {/* HEADER */}
              <div className="formgeneral-card-header">
                <div className="formgeneral-header-content">
                  <div className="formgeneral-header-title2">
                    <i className="fas fa-solid fa-envelope text-warning"></i> {t('Text_SENDEMAIL_Title')}
                  </div>
                  <div className="email-card-actions">
                    <button type="button" className="email-send-btn" onClick={handleSubmitDataEdit} >
                      {t('Text_Send').toUpperCase()}
                      <SendIcon sx={{ fontSize: 22, color: "white" }} />
                    </button> 
                     <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={cleanSettings} >
                      {t('Text_Clear')}
                    </button>  
                  </div>
                </div>
              </div>
              <br/>
              {/* FORM CARD */}
              <div className="formgeneral-card-form">
                <div className="email-header-title2">{t('Text_SENDEMAIL_Data')}</div>
                <hr className="sidebar-divider d-none d-md-block"/> 
                  <div className="form-group">  
                    <div className="row p-2">
                      {/* Tipo de Incidencia */}
                      <label className="text-primary" style={{ fontSize: 18 }}>
                        {t('Text_SENDEMAIL_EmailsTo')} :
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <div className="inicidents-input-wrapper">
                        <TextField
                          id="store_IdTo" 
                          name="store_IdTo"
                          value={formEMAIL.store_IdTo}
                          inputProps={{ style: {width:  i18n.language==="es"?550:550,  fontSize: '18px', }, maxLength: 100 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                          label={errorsEMAIL.store_IdTo!=null?t(errorsEMAIL.store_IdTo):t('PlaceHolder_SENDEMAIL_EmailsTo')}
                          placeholder={t('PlaceHolder_SENDEMAIL_EmailsTo')}
                          variant="outlined"
                          onBlur={handleBlurDataEditStoreTo}
                          onChange={handleChangeDataEditStoreTo}
                          select
                          SelectProps={{
                          native: true,
                          }}>
                          {emailsToSelect.map((option) => (
                          <option key={option.id} value={option.id}>
                              {option.tradename}  - {option.contacemail}
                          </option>
                          ))}
                        </TextField>
                      </div>
                    </div>  
                  </div>  
                 <div className="form-group">  
                    <div className="row p-2">
                      {/* Asunto */}
                      <label className="text-primary" style={{ fontSize: 18 }}>
                        {t('Text_SENDEMAIL_Subject')} :
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <TextField
                        id="subjectEmail"
                        name="subjectEmail"
                        value={formEMAIL.subjectEmail || ""}
                        inputProps={{
                          style: { width: i18n.language === "es" ? 893 : 889, fontSize: '18px' },
                          maxLength: 100
                        }}
                        InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                        label={errorsEMAIL.subjectEmail? t(errorsEMAIL.subjectEmail):t('PlaceHolder_SENDEMAIL_Subject')}
                        placeholder={t('PlaceHolder_SENDEMAIL_Subject')}
                        variant="standard"
                        onBlur={handleBlurDataEditEmail}
                        onChange={handleChangeDataEditEmail}
                      />
                    </div>
                  </div> 
                  <div className="form-group">  
                    <div className="row p-2">
                    {/* Contenido */}
                      <label className="text-primary" style={{ fontSize: 18 }}>
                        {t('Text_SENDEMAIL_Content')} :
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Textarea
                        id="contentEmail"
                        name="contentEmail"
                        value={formEMAIL.contentEmail}
                        label={errorsEMAIL.contentEmail?t(errorsEMAIL.contentEmail):t('PlaceHolder_SENDEMAIL_Content')}
                        placeholder={t('PlaceHolder_SENDEMAIL_Content')}
                        sx={{ width:i18n.language === "es" ? 872 : 891, fontSize: '18px' }}
                        variant="standard"
                        onBlur={handleBlurDataEditEmail}
                        onChange={handleChangeDataEditEmail}
                        minRows={10}
                        maxRows={15}
                      /> 
                    </div>
                  </div>  
                  <div className="form-group">
                    <div className="row p-2">
                      <div className="upload-box" style={{ width: '100%' }}>
                        <div className="upload-title">{t('Text_Select_Files')}</div>
                        <DropzoneAreaBase
                          initialFiles={files}
                          fileObjects={files}
                          acceptedFiles={[/* ...tus tipos... */]}
                          maxFileSize={20000000}
                          filesLimit={5}
                          onAdd={handleAddFileContract}
                          onDelete={handleDeleteFileContract}
                          showAlerts={false}
                          getPreviewIcon={handlePreviewIcon}
                          dropzoneText={t('Text_Select_Files')}
                          showPreviews
                          showPreviewsInDropzone={false}
                          useChipsForPreview
                          previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                          previewChipProps={{ classes: { root: 'upload-preview-chip' } }}
                          classes={{
                            root: 'upload-dropzone-root',
                            icon: 'upload-dropzone-icon',
                            text: 'upload-dropzone-text',
                          }}
                        />  
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </Box>
          {/* End Content Row */}
        </div>
      )}
    </div>
  );
};

SendEMAILSettings.propTypes = {
  showPrincipalMenu: PropTypes.bool.isRequired  
};

export default SendEMAILSettings;